export const RESUBMIT_MODEL = "RESUBMIT_MODEL";
export const getResubmitModel = (data) => {
    return {
        type: RESUBMIT_MODEL,
        payload: data
    }
}